import React, { useContext, useEffect, useRef, useState } from 'react';
import { View, Pressable, Switch } from 'react-native';

import DocsCard from 'app/src/components/Docs/Card';
import PrintOverlayDoc from 'app/src/components/Docs/Tags/PrintOverlay';
import ClientContext from 'app/src/contexts/ClientContext';
import { Button } from 'app/src/elements/buttons';
import { Text, Title, Setting, SettingLabel } from 'app/src/styles';
import colors from 'app/src/styles/colors';
import { rest } from 'app/src/utils/rest';
import { Link, useParams } from 'app/src/utils/routing';

const PrintOverlay = () => {
  const { id } = useParams();

  const { credentials, isMobile } = useContext(ClientContext);
  const [seeBOS, setSeeBOS] = useState(false);
  const iframeRef = useRef();

  const setupIframe = blob => {
    const dataUrl = window.URL.createObjectURL(blob);
    iframeRef.current.setAttribute('src', dataUrl);
  };

  const previewOverlay = () => {
    rest({
      path: `pdf/tag/${id}.pdf?bos=${seeBOS}`,
      options: { headers: { Accept: 'application/pdf' } },
      credentials,
    }).then(response => {
      response.blob().then(blob => setupIframe(blob));
    });
  };

  useEffect(() => {
    previewOverlay();
  }, [seeBOS]);

  return (
    <View style={{ height: '80vh' }}>
      <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
        <Title style={{ flex: 1 }}>Print Purchase Information Overlay</Title>
        <DocsCard title="Documentation" element={PrintOverlayDoc} />
      </View>

      <Setting>
        <SettingLabel>
          Print "See Bill of Sale" instead of Purchaser's Name?
        </SettingLabel>
        <Switch
          value={seeBOS}
          onValueChange={() => setSeeBOS(!seeBOS)}
          activeTrackColor={colors.lightButton}
          activeThumbColor={colors.button}
        />
      </Setting>

      <iframe ref={iframeRef} width="100%" height="100%"></iframe>

      <View
        style={{ flexDirection: isMobile ? 'column' : 'row', justifyContent: 'flex-end', gap: 16 }}
      >
        <Link to="/alignment" style={{ flex: 1, alignSelf: 'center' }}>
          <Text>⤇ Click here to adjust print alignment</Text>
        </Link>

        <Button
          label="Print"
          onPress={() => iframeRef.current.contentWindow.print()}
        />

        <Button
          label="Close"
          to="/pre-registrations"
          style={{ backgroundColor: '#303030' }}
        />
      </View>
    </View>
  );
};

export default PrintOverlay;
